export default __webpack_public_path__ + "53cc6991b9a3bf3c1d96107f72ee32f8.svg";